import { getErrorMessage } from "@/core/api/helpers"
import { useAppDispatch } from "@/redux/hooks"
import { useDeleteInboxResponseMutation } from "@/redux/services/inboxApi"
import { setToast } from "@/redux/toastSlice"

export const useDeleteInbox = () => {
  const dispatch = useAppDispatch()
  const [deleteInbox, response] = useDeleteInboxResponseMutation()

  const handleDeleteInbox = async (ids: string[]) => {
    try {
      const response = await deleteInbox(ids).unwrap()
      if (response) {
        dispatch(
          setToast({
            show: true,
            variant: "success",
            message: "Success delete inbox",
          }),
        )
      }
      return response
    } catch (error: any) {
      const message = getErrorMessage(error)
      dispatch(
        setToast({
          show: true,
          variant: "error",
          message,
        }),
      )
    }
  }

  return { deleteInbox: handleDeleteInbox, response }
}
